import { GatewayAssujetti } from "@conformite/gateway";
import { ColumnDefinition, Table } from "@endya-conformite/ui-kit";
import CheckFill from "@endya-conformite/ui-kit/src/assets/icons/check-circle-fill.svg?react";
import CheckIcon from "@endya-conformite/ui-kit/src/assets/icons/check.svg?react";
import PersonIcon from "@endya-conformite/ui-kit/src/assets/icons/person.svg?react";
import XFill from "@endya-conformite/ui-kit/src/assets/icons/x-circle-fill.svg?react";
import CrossIcon from "@endya-conformite/ui-kit/src/assets/icons/x-lg.svg?react";
import classNames from "classnames";
import {
  AssujettiFormType,
  assujettisFormTypeToLabel,
} from "./ControleQuinquennalAxeAssujettis";
import styles from "./ControleQuinquennalAxeAssujettis.module.scss";

type ControleQuinquennalAssujettiTableProps = {
  assujettiWithAvancement: {
    assujetti: GatewayAssujetti.AssujettiWithAvancement;
    avancement: number;
  }[];
  setSelectedAssujetti: (
    assujetti: GatewayAssujetti.AssujettiWithAvancement
  ) => void;
  axes: AssujettiFormType[];
};
export function ControleQuinquennalAssujettiTable({
  assujettiWithAvancement,
  setSelectedAssujetti,
  axes,
}: ControleQuinquennalAssujettiTableProps) {
  type AssujettiWithAvancement = (typeof assujettiWithAvancement)[number];
  const tableHeaders: ColumnDefinition<AssujettiWithAvancement>[] = [
    {
      key: "conforme",
      size: "max-content",
      render: ({ avancement }: AssujettiWithAvancement) => {
        const isConforme = avancement === 100;
        return isConforme ? (
          <CheckFill className={styles.conforme} />
        ) : (
          <XFill className={styles.notConforme} />
        );
      },
    },
    {
      key: "logo",
      size: "max-content",
      render: () => <PersonIcon />,
    },
    {
      key: "nom",
      size: "max-content",
      render: ({ assujetti }: AssujettiWithAvancement) => (
        <p className={styles.name}>
          {assujetti.surname} {assujetti.name}
        </p>
      ),
    },
    {
      key: "space",
      size: "1fr",
      render: () => <div />,
    },
    ...axes.map((assujettiAxe) => ({
      key: assujettiAxe,
      size: "max-content",
      render: ({ assujetti }: AssujettiWithAvancement) => {
        const avancement = assujetti.avancement[assujettiAxe] ?? 0;
        const isConforme = avancement === 100;
        return (
          <div className={styles.conformeContainer}>
            {isConforme && <CheckIcon className={styles.conforme} />}
            {!isConforme && (
              <CrossIcon
                className={classNames(
                  styles.notConforme,
                  styles.notConformeSmall
                )}
              />
            )}
            <p>{assujettisFormTypeToLabel[assujettiAxe]}</p>
          </div>
        );
      },
    })),
  ];
  return (
    <div className={styles.table}>
      <Table
        data={assujettiWithAvancement}
        columns={tableHeaders}
        hideHeader
        flatDesign
        noDarkenColor
        onRowClick={(row) => {
          setSelectedAssujetti(row.assujetti);
        }}
      />
    </div>
  );
}
